import { Student } from "@/types/tutor";
import Avatar from "@/components/Avatar";
import { getInitials } from "./lessonSequencingRules";

const StudentCard = ({ student }: { student: Student }) => {
  const picture = student.user.profile_picture?.trim();
  return (
    <div className="inline-flex items-center gap-2.5">
      {/* A student's own photo when they have one; otherwise initials in the
          workspace palette rather than the generic blue silhouette. */}
      {picture ? (
        <Avatar src={picture} alt={student.user.name} />
      ) : (
        <span className="et-student-mark" aria-hidden="true">
          {getInitials(student.user.name)}
        </span>
      )}
      <p className="font-mulish text-[15px] whitespace-nowrap">
        {student.user.name}
      </p>
    </div>
  );
};

export default StudentCard;
